type ElectronAuthSyncApi = {
  syncAuthToAllWindows?: () => Promise<{ success: boolean; error?: string }>;
  onAuthUpdated?: (callback: () => void) => () => void;
};

function electronApi(): ElectronAuthSyncApi | undefined {
  return (window as unknown as { electronAPI?: ElectronAuthSyncApi })
    .electronAPI;
}

/**
 * Tell the desktop main process that this screen just signed in, so every
 * other open screen gets an "auth:updated" event and can leave /login.
 * No-op in a browser, where there is no bridge and only one screen exists.
 */
export async function broadcastAuthToOtherScreens(): Promise<boolean> {
  const api = electronApi();
  if (!api?.syncAuthToAllWindows) return false;
  try {
    await api.syncAuthToAllWindows();
    return true;
  } catch {
    return false;
  }
}

/**
 * Listen for another screen's login broadcast. Returns an unsubscribe
 * function; a no-op unsubscribe if there is no bridge.
 */
export function onAuthBroadcast(callback: () => void): () => void {
  const api = electronApi();
  if (!api?.onAuthUpdated) return () => {};
  return api.onAuthUpdated(callback);
}
